import React from 'react'
import logo from '../assets/mainLogo.png'
        
const MainLogo = () => {
  return (
    <div className="relative h-[30.72px] w-[110.65px]">
          {/* <div className="h-[31px] w-[111px]">
            <div className="h-[31px]">
              <div className="h-[31px] w-[111px]">
                <div className="relative h-[31px]">
                  <div className="absolute left-0 top-0 h-[31px] w-[103px]">
                    <div className="relative h-[31px]">
                      <div className="absolute left-[68px] top-[7px] h-[17px] w-[23px] bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/group.png)] bg-[100%_100%]" />
                      <div className="absolute left-[49px] top-0 h-2.5 w-[11px] bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/mask-group.png)] bg-[100%_100%]" />
                      <div className="absolute left-2.5 top-[11px] h-5 w-7 bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/mask-group-1.png)] bg-[100%_100%]" />
                      <div className="absolute left-0 top-2.5 h-3.5 w-[103px] bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/mask-group-2.png)] bg-[100%_100%]" />
                      <div className="absolute left-[53px] top-[11px] h-[13px] w-[13px] bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/mask-group-3.png)] bg-[100%_100%]" />
                      <div className="absolute left-10 top-[11px] h-5 w-3.5 bg-[url(https://c.animaapp.com/m9qofkimNTaxBx/img/mask-group-4.png)] bg-[100%_100%]" />
                    </div>
                  </div>
                  <img
                    className="absolute left-[105px] top-[18px] h-1.5 w-1.5"
                    alt="Vector"
                    src="https://c.animaapp.com/m9qofkimNTaxBx/img/vector.svg"
                  />
                </div>
              </div>
            </div>
          </div> */}
          <img
            src={logo}
            alt="Syngenta logo" 
            className="w-32"
          />
        </div>
       
  )
}

export default MainLogo

